import React from 'react';
import PropTypes from 'prop-types';
import DateFnsUtils from '@date-io/date-fns';

import { Link } from 'react-router-dom';

import {
    Box,
    Button,
    Checkbox,
    IconButton,
    Tooltip,
    Typography,
    makeStyles
} from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import FlagIcon from '@material-ui/icons/Flag';

import OverflowTypography from '../../../../Common/UI/OverflowTypography';

const useStyles = makeStyles((theme) => style(theme));
const dateFns = new DateFnsUtils();

const propTypes = {
    ownership: PropTypes.object,
    isSelected: PropTypes.bool,
    siteCard: PropTypes.object,
    onSaveClick: PropTypes.func,
    onHoverEnter: PropTypes.func,
    onHoverLeave: PropTypes.func,
    onZoomFeature: PropTypes.func
};

const defaultProps = {
    ownership: null,
    isSelected: false,
    siteCard: null,
    onSaveClick: null,
    onHoverEnter: null,
    onHoverLeave: null,
    onZoomFeature: null
};

function ResultCard ({ ownership, isSelected, siteCard, onSaveClick, onHoverEnter, onHoverLeave, onZoomFeature }) {
    const classes = useStyles();
    const { polygonId, titleNo, proprietorName, proprietorCategory, proprietorAddress, proprietorTenure, date } = ownership;
    let proprietorNumber = ownership.companyRegistrationNo;

    // const polygonId = ownership.polygon_id;
    // const titleNo = ownership.title_no;
    // const proprietorName = ownership.proprietor_name;
    // const proprietorCategory = ownership.proprietorship_category;
    // const proprietorAddress = ownership.property_address;
    // const proprietorTenure = ownership.tenure;
    // const date = ownership.date_proprietor_added;
    // let proprietorNumber = ownership.company_registration_no;

    // TODO - Cleaning up the number inline here, really should be done in the data
    if (proprietorNumber) {
        for (let i = 0, t = Math.max(8 - proprietorNumber.length, 0); i < t; i++) {
            proprietorNumber = '0' + proprietorNumber;
        }
    }
    const url = proprietorNumber ? 
        `https://find-and-update.company-information.service.gov.uk/company/${proprietorNumber}` : 
        null;
    
    const color = '#b395f0';

    function handleChecked (event) {
        // const { id, onSelectCard } = this.props;
        // onSelectCard(id, event.target.checked);
    }

    function handleOnMouseEnter () {
        onHoverEnter && onHoverEnter(polygonId);
    }

    function handleOnMouseLeave () {
        onHoverLeave && onHoverLeave(polygonId);
    }

    function handleSaveSiteCard () {
        // const { id, siteCard, onSaveSiteCard } = this.props;
        console.log('Need to check that site card does not already exist');
        onSaveClick && onSaveClick(ownership);
        // if (!siteCard) { onSaveSiteCard(id, ''); }
    }

    function handleViewSiteCard () {
        // const { siteCard, onViewSiteCard } = this.props;
        // ToDo Update analysis on site card if already exists
        // if (siteCard) { onViewSiteCard(); }
    }

    function handleZoom () {
        onZoomFeature(ownership);
    }

    return (
        <div
            className={classes.root}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
            onClick={handleZoom}
        >
            {/* <div className={classes.checkboxContainer}>
                <Checkbox
                    checked={isSelected}
                    onChange={handleChecked}
                />
            </div> */}
            <div className={classes.text} onClick={handleZoom}>
                <div className={classes.title}>
                    {/* {siteCard && <FlagIcon color="secondary" />} */}
                    <OverflowTypography
                        className={classes.name}
                        color={siteCard ? 'secondary' : 'textPrimary'}
                        variant="subtitle1"
                    >
                        {siteCard ? siteCard.name : proprietorName}
                    </OverflowTypography>
                    {
                        Boolean(url) &&
                            <Link 
                                classes={{ root: classes.companiesHouseLinkRoot }}
                                href={url} 
                                target="_blank"
                            >
                                <Tooltip arrow title="View on Companies House" placement="right">
                                    <Box color="primary.light">
                                        <IconButton
                                            color="inherit"
                                            size="small"
                                            onClick={()=>{}}
                                        >
                                            <ExitToAppIcon />
                                        </IconButton>
                                    </Box>
                                </Tooltip>
                            </Link>
                    }
                    {/* <Typography color="textPrimary" variant="body2">
                        <AreaText area={area} />
                    </Typography> */}
                </div>
                <OverflowTypography color="textPrimary" variant="body2">
                    {titleNo}
                </OverflowTypography>
            </div>
            <div>
                {
                    siteCard ?
                        <Link className={classes.link} to={`/dashboard/sites/${siteCard.id}`}>
                            <Button
                                classes={{root:classes.buttonLink}}
                                variant="contained"
                                onClick={() => {}}
                            >
                                View
                            </Button>
                        </Link> :
                        <Button
                            classes={{root:classes.button}}
                            color="secondary"
                            variant="contained"
                            onClick={handleSaveSiteCard}
                        >
                            Save
                        </Button>
                }
            </div>
        </div>
    );
}

const style = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: 5,
        border: `1px solid ${theme.palette.background.border}`,
        '&:hover': {
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: `0px 0px 0px 1px ${theme.palette.secondary.light} inset`
        }
    },
    checkboxContainer: {
        display: 'flex',
        alignSelf: 'stretch',
        alignItems: 'center',
        backgroundColor: `${theme.palette.grey.variant5}1A`
    },
    text: {
        minWidth: 0,
        padding: 10,
        flexGrow: 1,
        '&:hover': {
            cursor: 'pointer'
        }
    },
    title: {
        display: 'flex',
        // justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 5,
        // '& > *:last-child':{
        //     marginLeft: 'auto'
        // }
    },
    chip: {
        borderRadius: 10,
        padding: '5px 10px',
        whiteSpace: 'nowrap',
        alignSelf: 'center',
        minWidth: 100,
        textAlign: 'center'
    },
    button: {
        margin: '0px 10px',
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        padding: '5px 10px',
        borderRadius: 10
    },
    buttonLink: {
        margin: '0px 10px',
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        padding: '5px 10px',
        borderRadius: 10,
        backgroundColor: theme.palette.primary.light
    },
    link: {
        textDecoration: 'none'
    },
    companiesHouseLinkRoot: {
        maxHeight: 17,
        display: 'flex',
        alignItems: 'center'
    }
});

ResultCard.propTypes = propTypes;
ResultCard.defaultProps = defaultProps;

export default ResultCard;